const PARTNER_ROLE = 1;

export const getContextualBackPath = (pathname = '', role = null) => {
  const path = String(pathname || '').toLowerCase();

  if (path.startsWith('/matches/')) {
    return role === PARTNER_ROLE ? '/partner-open-matches' : '/player-open-matches';
  }
  if (path.startsWith('/booking-invitation/')) return '/player-bookings';
  if (path.startsWith('/player-video-analysis/') || path.startsWith('/analysis/')) return '/player-video';
  if (path.startsWith('/partner-video-analysis/')) return '/partner-video';

  const parentRoutes = {
    '/player-booking-calendar': '/player-show-sport-centers?bookable=true',
    '/player-service-booking-calendar': '/player-show-sport-centers?bookable=true',
    '/player-replayer-tv-video-partner': '/player-replayer-tv-home',
    '/player-video-store-partner': '/player-video-store',
    '/partner-booking-calendar': '/partner-fields',
    '/partner-service-booking-calendar': '/partner-fields',
    '/partner-field-calendar': '/partner-fields',
    '/partner-service-calendar': '/partner-fields',
    '/partner-event': '/partner-events',
    '/partner-field': '/partner-fields',
    '/partner-service': '/partner-fields',
    '/partner-replayer-tv': '/partner-replayer-tv-home'
  };

  return parentRoutes[path] || null;
};
